(ns shared.core.indexed-db
  (:require [cljs.core.async :refer [put! chan]]
            [cognitect.transit :as t]
            [re-frame.core :as rf]))

(def indexed-db (or (.-indexedDB js/window)
                    (.-mozIndexedDB js/window)
                    (.-webkitIndexedDB js/window)
                    (.-msIndexedDB js/window)))
(def indexed-db? (exists? indexed-db))
(def transit-read-handlers (atom {}))
(def transit-write-handlers (atom {}))
(def read-write-perm "readwrite")

(rf/reg-event-db
  :indexed-db/init
  (fn [db [_ idb]]
    (assoc db :indexed-db idb)))

(defn db-indexed-db [db]
  (:indexed-db db))

(rf/reg-sub :indexed-db/db- db-indexed-db)

(defn indexed-db-key-version [db key]
  (get-in db (conj [:indexed-db-key-versions] key)))

(rf/reg-event-db
  :indexed-db/update-key-versions
  (fn [db [_ keys]]
    (let [new-version (str (random-uuid))]
      (assoc db :indexed-db-key-versions (merge (:indexed-db-key-versions db)
                                                (some->> keys (map (fn [k] [k new-version])) (into {})))))))

(defn clj->json [x]
  (t/write (t/writer :json {:handlers @transit-write-handlers}) x))

(defn json->clj [x]
  (t/read (t/reader :json {:handlers @transit-read-handlers}) x))

(defn create-object-store [idb {:keys [table-name key-path auto-increment? indexes]
                                :or {auto-increment? false}}]
  (when idb
    (let [object-store (.createObjectStore idb table-name #js {:keyPath key-path :autoIncrement auto-increment?})]
      (for [{:keys [kind unique?]} indexes] (.createIndex object-store kind kind #js {:unique unique?}))
      (set! (.. object-store -transaction -oncomplete)
            (fn [_]
              (-> idb (.transaction table-name read-write-perm) (.objectStore table-name)))))))

(defn get-object-store [idb {:keys [table-name on-complete on-error]}]
  (when idb
    (when-let [transaction (some-> idb (.transaction #js [table-name] read-write-perm))]
      (some->> on-complete (set! (.-oncomplete transaction)))
      (some->> on-error (set! (.-onerror transaction)))
      (.objectStore transaction table-name))))

(defn add-object-store [idb {:keys [table-name key-path values on-complete on-error]
                             :or {key-path "key"}}]
  (when idb
    (when-let [object-store (get-object-store idb {:table-name table-name
                                                   :on-complete on-complete
                                                   :on-error on-error})]
      (rf/dispatch [:indexed-db/update-key-versions (some->> values (map #(get % key-path)))])
      (some->> values (mapv #(-> object-store (.put (->> %
                                                         (map (fn [[k v]] [k (clj->json v)]))
                                                         (into {})
                                                         (clj->js)))))))))

(defn get-object-store-val-chan [idb {:keys [table-name key-path transf]}]
  (when idb
    (when-let [req (some-> (get-object-store idb {:table-name table-name}) (.get (clj->json key-path)))]
      (let [val-chan (chan)]
        (set! (.-onsuccess req) #(when-let [v (some-> (.-result req) (.-value) (json->clj))]
                                   (rf/dispatch [:indexed-db/update-key-versions [key-path]])
                                   (put! val-chan (if transf (transf v) v))))
        val-chan))))

(defn clear-object-store [idb table-name]
  (some-> (get-object-store idb {:table-name table-name}) (.clear)))

(defn init [{:keys [db-name version table clear-data?]}]
  (when indexed-db?
    (let [req (.open indexed-db db-name version)]
      (set! (.-onerror req) #(js/console.warn (str "Could not initialize " db-name) %))
      (set! (.-onsuccess req)
            (fn [e]
              (let [idb (.. e -target -result)]
                (rf/dispatch-sync [:indexed-db/init idb])
                (when (and clear-data? idb) (clear-object-store idb (:table-name table))))))
      (set! (.-onupgradeneeded req)
            (fn [e]
              (let [idb (.. e -target -result)]
                (rf/dispatch-sync [:indexed-db/init idb])
                (create-object-store idb table)))))))
